import { Box, styled, Typography } from '@mui/material';
import TeamCardsCarousel from './TeamCardAnimation';
import axios from 'axios';
import { useEffect, useState } from 'react';


const MainContainer = styled(Box)(({ theme }) => ({
  background: "#000",
  display: "flex",
  flexDirection: "column",
  padding: "32px 24px",
  position: "relative",
  overflow: "hidden",

  "&::after": {
    content: '""',
    position: "absolute",
    width: "95%",
    height: "80%",
    right: "65%",
    top: "10%",
    bottom: "10%",
    transform: "translateX(-100%), translateY(-50%)",
    background:
      "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
    filter: "blur(100px)",
    //backdropFilter: "blur(500px)",
    zIndex: 0,
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%", 
  maxWidth: "1200px",
  margin: "0 auto",
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const TeamCarousel = () => {
  const [teamMemberData, setTeamMemberData] = useState(null);
  
    useEffect(() => {
      getTeamsList();
    }, []);
  
  
    const getTeamsList = async (page = 1, limit = 100) => {
      try {
        let url = `https://dev.ienergydigital.com/task-api/api/cms/entries/?type=teams&page=${page}&limit=${limit}`;
        const response = await axios.get(url);
        setTeamMemberData(response.data?.data?.entries||[]);
      } catch (error) {
        console.error(error);
      }
    };

  return (
    <MainContainer>
     <ContentContainer>
         <Box>
            <Typography variant="h1" sx={{
              fontSize: '40px',
              fontWeight: 600,
              lineHeight: 1.2,
              textAlign: 'center',
              mb: 6,
              background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              letterSpacing: '-0.5px'
            }}>
              The People Behind Energy
            </Typography>
            <Typography variant="body1" sx={{
              fontSize: '18px',
              lineHeight: 1.6,
              textAlign: 'center',
              maxWidth: '800px',
              mx: 'auto',
              mb: '48px',
              color: '#8C8CC2',
            }}>
              We are a team of innovators, technologists, and problem-solvers committed to transforming complex challenges into actionable insights. With a focus on creating intuitive and scalable dashboards, we enable organizations to thrive in an ever-changing landscape.
            </Typography>
        </Box>
        <TeamCardsCarousel teamMemberData={teamMemberData} />
      </ContentContainer>
    </MainContainer>
    
  );
};

export default TeamCarousel;